import { render, staticRenderFns } from "./MedicinesBlock.vue?vue&type=template&id=5b622adc&lang=pug&"
import script from "./MedicinesBlock.vue?vue&type=script&lang=js&"
export * from "./MedicinesBlock.vue?vue&type=script&lang=js&"
import style0 from "./MedicinesBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports